// UploadDocumentPage.tsx
import ApplicantTabs from "../common-features/ApplicantTabs/ApplicantTabs";

const UploadDocument = ({
  isLoading,
  tabsList,
  tabsListLoading,
  applicationDetail,
  mainApplicantDetails,
  coApplicantDetails,
  applicationId,
  handleFetchApplicationDetail,
  partnerStartedJourney,
  enableCustomerJourney,
  setPartnerStartedJourney,
  hideHeaderActions = false,
  headerActionsPortalTarget = null,
  headerActionsOnly = false,
  disableHeaderActionsPortal = false,
}: any) => {
  return (
    <ApplicantTabs
      isApplicantTabsLoading={isLoading}
      applicants={tabsList}
      tabsListLoading={tabsListLoading}
      applicationId={applicationId}
      applicationDetail={applicationDetail}
      mainApplicantDetails={mainApplicantDetails}
      coApplicantDetails={coApplicantDetails}
      handleFetchApplicationDetail={handleFetchApplicationDetail}
      partnerStartedJourney={partnerStartedJourney}
      enableCustomerJourney={enableCustomerJourney}
      setPartnerStartedJourney={setPartnerStartedJourney}
      hideHeaderActions={hideHeaderActions}
      headerActionsPortalTarget={headerActionsPortalTarget}
      headerActionsOnly={headerActionsOnly}
      disableHeaderActionsPortal={disableHeaderActionsPortal}
    />
  );
};

export default UploadDocument;
